// Re-exports from unified color system
import { PRIMITIVE_COLORS, SEMANTIC_COLORS, COMPONENT_COLORS } from '../residentColors';

export const CHAT_MOBILE_COLORS = {
  background: SEMANTIC_COLORS.background.primary,
  cardBackground: SEMANTIC_COLORS.background.secondary,
  frameBackground: SEMANTIC_COLORS.background.primary,
  inputBackground: PRIMITIVE_COLORS.white5,
  avatarBackground: PRIMITIVE_COLORS.white10,
  sentMessageBubble: COMPONENT_COLORS.chat.sentBubble,
  receivedMessageBubble: COMPONENT_COLORS.chat.receivedBubble,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textSecondary: PRIMITIVE_COLORS.gray200,
  textMuted: PRIMITIVE_COLORS.gray400,
  textPlaceholder: PRIMITIVE_COLORS.gray300,
  textLabel: PRIMITIVE_COLORS.white80,
  textTimestamp: PRIMITIVE_COLORS.white70,
  accentPink: PRIMITIVE_COLORS.resioPink,
  accentBlue: PRIMITIVE_COLORS.resioBlue,
  accentBlueBorder: PRIMITIVE_COLORS.resioBlueBorder,
  divider: PRIMITIVE_COLORS.gray700,
  borderLight: PRIMITIVE_COLORS.gray800,
  iconPrimary: SEMANTIC_COLORS.icon.primary,
  iconSecondary: SEMANTIC_COLORS.icon.secondary,
  iconDark: SEMANTIC_COLORS.icon.inverse,
  buttonActive: PRIMITIVE_COLORS.resioBlue,
  buttonInactive: PRIMITIVE_COLORS.gray600,
  buttonDisabled: PRIMITIVE_COLORS.gray600,
  searchBackground: PRIMITIVE_COLORS.white5,
  unreadIndicator: '#F24913',
  headerBackground: SEMANTIC_COLORS.background.secondary,
} as const;

export type ChatMobileColor = keyof typeof CHAT_MOBILE_COLORS;
